import React, { useState, useEffect } from 'react';
import ContentPage from '../components/ContentPage';
import { publicApi } from '../lib/api';

export default function MenusPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    publicApi.getCurrentMenu().then((res) => setData(res.data)).catch(() => setData(null));
  }, []);

  const menu = data?.menu;
  const season = data?.season;
  const categories = (menu?.categories || []).filter((c) => (c.recipes || []).length > 0);

  return (
    <ContentPage
      pageId="menus"
      relatedLinks={[
        { to: '/comment-ca-marche', label: 'Découvrir comment fonctionne Mitonner' },
        { to: '/tarifs', label: 'Voir les tarifs de préparation de repas à domicile' },
        { to: '/zone-intervention', label: 'Consulter notre zone d\u2019intervention' },
      ]}
    >
      <div data-testid="menus-dynamic" className="mb-6">
        {season?.name && (
          <p className="text-sm font-medium text-[#C86B51] mb-4" data-testid="menus-season">Saison : {season.name}</p>
        )}
        {categories.length > 0 ? (
          <div className="space-y-6">
            {categories.map((cat, ci) => (
              <div key={ci} className="bg-white rounded-2xl border border-[#E3DED5] p-6" data-testid={`menu-category-${ci}`}>
                <h2 className="font-['Cormorant_Garamond'] text-2xl font-semibold text-[#2A312C] mb-3">{cat.name}</h2>
                <ul className="space-y-1.5">
                  {(cat.recipes || []).map((r, ri) => (
                    <li key={ri} className="text-[#5C6A61] flex items-start gap-2">
                      <span className="text-[#A5BBA8] mt-1">•</span>
                      <span>{r.name}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-2xl border border-[#E3DED5] p-6 text-[#5C6A61]" data-testid="menus-empty">
            Le menu de la saison en cours sera affiché ici dès qu’il sera disponible.
          </div>
        )}
      </div>
    </ContentPage>
  );
}
